import KedoApi from "./KedoApi";

const DossierApi = new KedoApi("/dossier");
const defDossierApi = new KedoApi("/defdossier");

export { DossierApi, defDossierApi };
